define('GameDayCore/GDModel/ValueObjects/Linescore/Linescore',['require','exports','module','../ValueObjectFactory','../../../GDUtil/dataMapping/GameStateUtil','../../../GDControl/GameModelLocator/GameModelLocator','./LinescoreInnings','./LinescorePitcher','./LinescoreMedia','./LinescoreHomeruns','extant/extant'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
        util = require("../../../GDUtil/dataMapping/GameStateUtil"),
        GameModelLocator = require("../../../GDControl/GameModelLocator/GameModelLocator");

	VO.create(Linescore);

	function Linescore($data) {
		// console.log("LINESCORE! ")
		var vo = VO.ensureVO(this, Linescore),
			data = $data,
			LinescoreInnings = require('./LinescoreInnings'),
			LinescorePitcher = require('./LinescorePitcher'),
			LinescoreMedia = require('./LinescoreMedia'),
			LinescoreHomeruns = require( './LinescoreHomeruns' ),
            exists = require('extant/extant'),
			gid = data.id.split("/").join("_").split("-").join("_"),
			linescore = new LinescoreInnings(data);

		vo.gameItem = GameModelLocator.getCurrentGame();
		vo.gdid = data.id;
		vo.id = gid || "",
		vo.venue = data.venue || "",
		vo.game_pk = data.game_pk || "",
		vo.time = data.time || "",
		vo.time_date = data.time_date || "",
		vo.resume_date = data.resume_date || "",
		vo.time_date_aw_lg = data.time_date_aw_lg || "",
		vo.time_date_hm_lg = data.time_date_hm_lg || "",
		vo.time_zone = data.time_zone || "",
		vo.ampm = data.ampm || "",
		vo.first_pitch_et = data.first_pitch_et || "",
		vo.away_time = data.away_time || "",
		vo.away_time_zone = data.away_time_zone || "",
		vo.away_ampm = data.away_ampm || "",
		vo.home_time = data.home_time || "",
		vo.home_time_zone = data.home_time_zone || "",
		vo.home_ampm = data.home_ampm || "",
		vo.game_type = data.game_type || "",
		vo.tiebreaker_sw = data.tiebreaker_sw || "",
		vo.original_date = data.original_date || "",
		vo.time_zone_aw_lg = data.time_zone_aw_lg || "",
		vo.time_zone_hm_lg = data.time_zone_hm_lg || "",
		vo.time_aw_lg = data.time_aw_lg || "",
		vo.aw_lg_ampm = data.aw_lg_ampm || "",
		vo.tz_aw_lg_gen = data.tz_aw_lg_gen || "",
		vo.time_hm_lg = data.time_hm_lg || "",
		vo.hm_lg_ampm = data.hm_lg_ampm || "",
		vo.tz_hm_lg_gen = data.tz_hm_lg_gen || "",
		vo.venue_id = data.venue_id || "",
		vo.scheduled_innings = data.scheduled_innings || "",
		vo.away_name_abbrev = data.away_name_abbrev || "",
		vo.home_name_abbrev = data.home_name_abbrev || "",
		vo.away_code = data.away_code || "",
		vo.away_file_code = data.away_file_code || "",
		vo.away_team_id = data.away_team_id || "",
		vo.away_team_city = data.away_team_city || "",
		vo.away_team_name = data.away_team_name || "",
		vo.away_division = data.away_division || "",
		vo.away_league_id = data.away_league_id || "",
		vo.away_sport_code = data.away_sport_code || "",
		vo.home_code = data.home_code || "",
		vo.home_file_code = data.home_file_code || "",
		vo.home_team_id = data.home_team_id || "",
		vo.home_team_city = data.home_team_city || "",
		vo.home_team_name = data.home_team_name || "",
		vo.home_division = data.home_division || "",
		vo.home_league_id = data.home_league_id || "",
		vo.home_sport_code = data.home_sport_code || "",
		vo.day = data.day || "",
		vo.gameday_sw = data.gameday_sw || "",
		vo.double_header_sw = data.double_header_sw || "",
		vo.away_games_back = data.away_games_back || "",
		vo.home_games_back = data.home_games_back || "",
		vo.home_games_back_wildcard = data.home_games_back_wildcard || "",
		vo.venue_w_chan_loc = data.venue_w_chan_loc || "",
		vo.gameday_link = data.gameday_link || "",
		vo.away_win = data.away_win || "",
		vo.away_loss = data.away_loss || "",
		vo.home_win = data.home_win || "",
		vo.home_loss = data.home_loss || "",
		vo.game_data_directory = data.game_data_directory || "",
		vo.league = data.league || "",
		vo.top_inning = data.top_inning || "",
		vo.inning_state = data.inning_state || "",

		vo.ind = data.ind || "",
		vo.status_ind = data.ind || "";

		vo.status = data.status || "";
		vo.status_reason = data.reason || "";
		vo.gamestate = data.status || "";
		vo.liveState = util.getUsableGameState(data.ind,true);
		vo.viewState = util.getUsableGameState(data.ind);
		vo.abstractGameState = util.getAbstractGamestate(data.status);
		vo.displayFinalStatus = util.getDisplayFinalState(data.status, data.scheduled_innings || "", [].concat($data.linescore || $data.inning_line_score).length);
		vo.displayFinalStatusShort = util.getDisplayFinalState(data.status, data.scheduled_innings || "", [].concat($data.linescore || $data.inning_line_score).length);

		vo.inning = data.inning || linescore.inning || "",
		vo.balls = data.balls || "",
		vo.strikes = data.strikes || "",
		vo.outs = data.outs || "",
		vo.away_team_runs = data.away_team_runs || "",
		vo.home_team_runs = data.home_team_runs || "",
		vo.away_team_hits = data.away_team_hits || "",
		vo.home_team_hits = data.home_team_hits || "",
		vo.away_team_errors = data.away_team_errors || "",
		vo.home_team_errors = data.home_team_errors || "",
		vo.wrapup_link = data.wrapup_link || "",
		vo.home_preview_link = data.home_preview_link || "",
		vo.away_preview_link = data.away_preview_link || "",
		vo.preview = data.preview || "",
		vo.tv_station = data.tv_station || "",
		vo.home_recap_link = data.home_recap_link || "",
		vo.away_recap_link = data.away_recap_link || "",
		vo.photos_link = data.photos_link || "",
		vo.linescore = linescore.innings,
		vo.losing_pitcher = (exists(data.losing_pitcher)) ? new LinescorePitcher(data.losing_pitcher) : null,
		vo.winning_pitcher = (exists(data.winning_pitcher)) ? new LinescorePitcher(data.winning_pitcher) : null,
		vo.save_pitcher = (exists(data.save_pitcher)) ? new LinescorePitcher(data.save_pitcher) : null,
		vo.home_run_hitters = new LinescoreHomeruns(data.home_runs, vo.home_code, vo.away_code);
		vo.game_media = new LinescoreMedia(data.game_media && data.game_media.media || { });
    }

	return Linescore;
});
